/**
 * Варианты пополнения и сумма по умолчанию в зависимости от названия тарифа (как в БД).
 */

const STANDARD_PRESETS = [
    { value: 150, bonus: 0, months: '1 месяц' },
    { value: 300, bonus: 0, months: '2 месяца' },
    { value: 500, bonus: 100, months: '4 месяца' },
    { value: 1000, bonus: 500, months: '10 месяцев' },
    { value: 1200, bonus: 600, months: '12 месяцев' },
];

const PRO_PRESETS = [
    { value: 300, bonus: 0, months: '1 месяц' },
    { value: 500, bonus: 100, months: '2 месяца' },
    { value: 1000, bonus: 500, months: '5 месяцев' },
    { value: 1200, bonus: 600, months: '6 месяцев' },
    { value: 2000, bonus: 1600, months: '12 месяцев' },
];

const LEGACY_PRESETS = [
    { value: 100, bonus: 0, months: '1 месяц' },
    { value: 300, bonus: 0, months: '3 месяца' },
    { value: 500, bonus: 100, months: '6 месяцев' },
    { value: 1000, bonus: 500, months: '15 месяцев' },
    { value: 1200, bonus: 600, months: '18 месяцев' },
];

const LEGACY_PRO_PRESETS = [
    { value: 200, bonus: 0, months: '1 месяц' },
    { value: 400, bonus: 0, months: '2 месяца' },
    { value: 500, bonus: 100, months: '3 месяца' },
    { value: 1000, bonus: 500, months: '7,5 месяцев' },
    { value: 1200, bonus: 600, months: '9 месяцев' },
];

/**
 * @param {string | null | undefined} tariffName — например Standard, Pro, Legacy, Legacy Pro
 * @returns {{ defaultAmount: number, presets: Array<{ value: number, bonus: number, months: string }> }}
 */
export function getTopupPresetsForTariff(tariffName) {
    const key = normalizeTariffKey(tariffName);
    switch (key) {
        case 'pro':
            return { defaultAmount: 300, presets: PRO_PRESETS };
        case 'legacy':
            return { defaultAmount: 100, presets: LEGACY_PRESETS };
        case 'legacy_pro':
            return { defaultAmount: 200, presets: LEGACY_PRO_PRESETS };
        case 'standard':
        default:
            return { defaultAmount: 150, presets: STANDARD_PRESETS };
    }
}

function normalizeTariffKey(tariffName) {
    const s = String(tariffName || '')
        .trim()
        .toLowerCase();
    if (s === 'legacy pro' || s === 'legacypro') return 'legacy_pro';
    if (s === 'legacy') return 'legacy';
    if (s === 'pro') return 'pro';
    if (s === 'standard') return 'standard';
    return 'standard';
}
